<!-- 套题 -->
<template>
  <div class="essay">
    <div class="content" v-if="info">
      <div class="title fontSize14">
        <!-- <span class="paper_blue">【{{ quesMap[info.type] }}】</span> -->
        <span>{{ no + 1 }}、</span>
        <span v-html="reformHtml(info.content)"></span>
      </div>
      <div v-for="(tItem, tIndex) in info.children" :key="tIndex">
        <template v-if="tItem.type == 'SINGLECHOICE' || tItem.type == 'MULTIPLECHOICE' || tItem.type == 'JUDGMENT'">
          <choice :info="tItem" :readOnly="tItem.readOnly" :no="tIndex" :submit="submit" v-model="answers[tItem.id]" @input="change"
            @submit="changeSubmit"></choice>
        </template>
        <template v-else-if="tItem.type == 'BLANKFILL'">
          <blank :info="tItem" :readOnly="tItem.readOnly" :no="tIndex" :submit="submit" v-model="answers[tItem.id]" @input="change"
            @submit="changeSubmit">
          </blank>
        </template>
        <template v-else>
          <essay :info="tItem" :readOnly="tItem.readOnly" :no="tIndex" :submit="submit" v-model="answers[tItem.id]" @input="change"
            @submit="changeSubmit"></essay>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { quesMap } from "@/utils/enum.js";
import choice from "@/components/question/choice.vue";
import blank from "@/components/question/blank.vue";
import essay from "@/components/question/essay.vue";

export default {
  name: "tt",
  components: {
    choice,
    blank,
    essay,
  },
  props: {
    info: {},
    readOnly: false,
    submit: true,
    value: {
      default: "",
    },
    no: ''
  },
  data () {
    return {
      quesMap,
      answers: {},
      answer: '',
    };
  },
  watch: {
    info: {
      handler: function (n, o) {
        this.info.children.forEach(item => {
          if (item.studentAnswer) {
            item.readOnly = true
            this.answers[item.id] = item.studentAnswer
          } else if (item.answer) {
            item.readOnly = true
            this.answers[item.id] = item.answer
          }
        });
        this.$forceUpdate();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    change (data) {
      this.answer = data
      this.$emit("input", this.answers);
    },
    reformHtml (html) {
      return html.replace(/<p.*?>/gi, "").replace(/<\/p.*?>/gi, "");
    },
    changeSubmit (id) {
      const params = {
        dbId: this.info.dbId,
        orgId: this.info.orgId,
        questionId: id,
        answer: this.answer
      };
      // addPracticeLearn(params).then((res) => {
      //   this.info.children.forEach(item => {
      //     if (item.id == id) {
      //       item.readOnly = true
      //       item.isCorrect = res.isCorrect
      //     }
      //   });
      //   this.$forceUpdate();
      // });
    },
  },
};
</script>

<style lang="scss">
.essay {
  .paper_blue {
    color: #3677EA;
  }

  .paper_red {
    color: #FF2929;
  }

  .next_last {
    text-align: right;
    // border-bottom: 1px solid #D2D2D2;
    // padding: 50px 0;
  }

  .content {
    .title {
      margin-bottom: 15px;
      line-height: 20px;
    }

    .txts {
      textarea {
        width: 100%;
        border: 1px solid #e1e1e1;
        border-radius: 10px;
        height: 100px;
        line-height: 20px;
        margin-bottom: 15px;
        box-sizing: border-box;
        padding: 5px 10px;
        font-size: 14px;
      }
    }

    .analysisBox {
      box-sizing: border-box;
      padding: 5px 10px;
      margin: 50px 0 0 0;

      div {
        margin: 20px 0;
      }

      .stjx {
        display: flex;

        span {
          width: 420px;
          display: inline-block;
        }
      }

      .stjx-title {
        text-align: center;
        border-top: 1px solid #D2D2D2;
        padding-top: 30px;
        font-size: 14px;
        color: #E03019;
      }
    }
  }
}
</style>
